import { Store } from '@ngxs/store';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { ConfigState, UserState } from '../../core/state';

@Component({
  selector: 'app-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton],
})
export class NoAccessComponent {
  private readonly store = inject(Store);

  contactDetails = this.store.selectSignal(ConfigState.contactDetails);

  onAskForAccessClick(): void {
    const user = this.store.selectSignal(UserState.user);
    const { receiver, subject, body } = {
      receiver: this.contactDetails().dicAdminEmail,
      subject: `Access to dictionary service`,
      body:
        `Hi,%0D%0A Our team wants to use Dictionary Service.` +
        ` Could you please add APPLICATION_NAME to the Dictionary Service?%0D%0A%0D%0A${user()?.given_name} ${user()?.family_name}`,
    };
    window.open(`mailto:${receiver}?subject=${subject}&body=${body}`, '_self');
  }
}
